export default "__VITE_ASSET__BZarXaSv__"